import { GraphNodeData } from "@store/services/converter/types"
import { GraphStoreType } from "@features/graph/Graph"
import { Node } from "reactflow"
import {
  LOCAL_SCENARIO_HASH,
  graphGetIndexedDbData,
  graphSaveIndexedDb,
} from "@features/graph/state/indexedDBHelpers"

export const graphReplaceNode = async (
  graphStore: GraphStoreType,
  graphKey: string,
  saveStack: Node<GraphNodeData>[],
) => {
  const graphData = await graphGetIndexedDbData(graphKey)
  if (!graphData?.data) {
    return
  }
  const { data } = graphData
  const { nodeInternals, edges } = graphStore.getState()
  for (const node of saveStack) {
    data.nodeMap[node.id] = Object.freeze(node.data)
    const n = nodeInternals.get(node.id)
    if (!n) {
      continue
    }
    n.data = node.data
    nodeInternals.set(node.id, n)
  }
  graphStore.setState({ nodeInternals, edges })
  await graphSaveIndexedDb(graphKey, data, LOCAL_SCENARIO_HASH, true)
}
